<template>
    <div>
      <table class="table">
        <thead>
          <slot name="columns">
            <tr><th v-for="(column, index) in columns" :key="index">{{column.text}}</th></tr>
          </slot>
        </thead>
        <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <slot :row="item">
            <td v-for="(column, index) in columns" :key="index" v-if="hasValue(item, column.value)">
              <span v-if="column.value=='created_at' || column.value=='date' || column.value=='status' || column.value=='total'">
                <span v-if="column.value=='created_at' || column.value=='date'">
                  {{(itemValue(item, column.value)).slice(0,16).replace('T',' ')}}
                </span>
                <span v-if="column.value=='total'">
                  {{(itemValue(item, column.value)).toLocaleString('en-EN', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  }).replace(/\,/g, '.')}}
                </span>
                <span v-if="column.value=='status' && item.status">
                  Activo
                </span>
                <span v-if="column.value=='status' && !item.status">
                  Inactivo
                </span>
              </span>
              <span v-else>
                {{itemValue(item, column.value)}}
              </span>
              <span style="display: flex;" v-if="column.value=='options'">
                <vs-tooltip :key="index" v-if="(rol!=2 && option.action=='delete') || option.action!='delete'" :text="option.text" v-for="(option, index) in options">
                  <button type="button" class="navbar-toggler navbar-toggler-right" aria-controls="navigation-index"
                    aria-expanded="false" aria-label="Toggle navigation" @click="sendAction(item, option.action)">
                    <i style="color: #004aad;" :class="'nc-icon '+option.icon"></i></button>
                </vs-tooltip>
              </span>
            </td>
          </slot>
        </tr>
        </tbody>
      </table>
    </div>
  </template>
  <script>
  import Vue from 'vue'
  import vuesax from 'vuesax'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import 'vuesax/dist/vuesax.css'
  import 'material-icons/iconfont/material-icons.css';
  import getSecret from '../helpers/get-secret';
  const serverUrl=getSecret('SERVER_URL');
  Vue.use(vuesax)
  
    export default {
      name: 'l-table',
      props: {
        columns: Array,
        options: Array,
        data: Array
      },
      components: {
        StatsCard
      },
      data() {
        return{
          id_company:JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
          rol:JSON.parse(localStorage.getItem('jwt_user')).rol,
        }
      },
      methods: {
        hasValue (item, column) {
          return item[column.toLowerCase()] !== 'undefined'
        },
        itemValue (item, column) {
          return item[column.toLowerCase()]
        },
        sendAction(item, action){
          this.$emit(action, item)
        }
      }
    }
  </script>
  <style>
    input {
      height: auto!important;
    }
    .vs-input{
      float: left;
      width: 50%;
      margin-top: 5px;
    }
    .vs-select{
      float: left;
      width: 50%;
      margin-top: 5px;
    }
    .con-select {
      width: auto!important;;
      clear: both;
    }
    .vs-button {
      height: auto!important;;
    }
    @media (max-width: 767px) {
      .viewMobile{
        display: none;
      }
      .buttonMobile{
        padding-top: 3%;
      }
      .buttonsCommandMobile{
        flex-direction: column;
      }
    }
    .card {
      margin-bottom: 10px!important;
  }
  </style>
  